import { render, staticRenderFns } from "./person_settle_table.vue?vue&type=template&id=0dcbfc2c"
import script from "./person_settle_table.vue?vue&type=script&lang=ts"
export * from "./person_settle_table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports